export const winbackKeys = {
  all: ["winbacks"] as const,
  details: () => [...winbackKeys.all, "detail"] as const,
  detail: (account_id: string) =>
    [...winbackKeys.details(), account_id] as const,
}
